import PropTypes from 'prop-types'
import Image from 'next/image'

import Typography from '../../typography'
import RawHTML from '../../../common/raw-html'

const Body = ({ content = [] }) => {
  return content.length > 0
    ? content.map(item => {
      if (item.type === 'p') {
        return <Typography
          key={item.id}
          tag='div'
          size={'three'}
          weight={'regular'}
          className={'mb-4'}>
          <RawHTML html={item.value} />
        </Typography>
      }

      if (item.type.startsWith('h')) {
        const titleProps = {
          h2: { size: 'four', weight: 'bold' },
          h3: { size: 'three', weight: 'medium' },
          h4: { size: 'two', weight: 'medium' },
          h5: { size: 'two', weight: 'regular' },
          h6: { size: 'two', weight: 'regular' }
        }
        return <Typography
          key={item.id}
          tag={item.type}
          {...titleProps[item.type]}
          className={'mb-4'}>
          <RawHTML html={item.value} />
        </Typography>
      }

      if (item.type.startsWith('ordered_list')) {
        return <ol
          className={'list-decimal pl-10'}
          key={item.id}>
          {
            item.value.map((value, index) => {
              return <Typography
                key={index}
                tag={'li'}
                className={'mb-4'}>
                <RawHTML html={value} />
              </Typography>
            })
          }
        </ol>
      }

      if (item.type.startsWith('unordered_list')) {
        return <ul
          className={'list-disc pl-10'}
          key={item.id}>
          {
            item.value.map((value, index) => {
              return <Typography
                key={index}
                tag={'li'}
                className={'mb-4'}>
                <RawHTML html={value} />
              </Typography>
            })
          }
        </ul>
      }

      if (item.type.startsWith('quote')) {
        return <blockquote
          key={item.id}
          className={'mb-4 p-5 md:p-10'}>
          <Typography
            tag={'div'}
            size={'large'}
            className={item.value.author ? 'mb-4' : ''}>
            <Typography
              tag={'sup'}
              type={'title'}
              size={'large'}
              className={'inline-block float-left text-light-blue-01'}>
              {'"'}
            </Typography>
            <RawHTML html={item.value.text} />
          </Typography>
          {
            item.value.author
              ? <em
                className={'italic text-gray-01'}>
                {item.value.author}
              </em>
              : ''
          }
        </blockquote>
      }

      if (item.type.startsWith('embed')) {
        const caption = item.value.caption
          ? <Typography
            tag={'div'}
            size={'small'}
            className={'italic text-gray-01 mt-2 text-center'}>
            <RawHTML html={item.value.caption} />
          </Typography>
          : ''

        if (item.value.embedRaw !== '') {
          return <div
            key={item.id}
            className={`${item.value.embedRatio} oembed-wrapper mb-4`}>
            <div className="iframe-wrapper">
              <RawHTML html={item.value.embedRaw} />
            </div>
            {caption}
          </div>
        }

        return <div
          key={item.id}
          className={`${item.value.embedRatio} oembed-wrapper mb-4`}>
          <div className="iframe-wrapper">
            <RawHTML html={item.value.embedObject.html} />
          </div>
          {caption}
        </div>
      }

      if (item.type === 'table') {
        const caption = item.value.table_caption
          ? <Typography
            tag={'div'}
            size={'small'}
            className={'block italic text-gray-01 mt-2 text-center'}>
            <RawHTML html={item.value.table_caption} />
          </Typography>
          : ''

        return <div
          key={item.id}
          className={'table-wrapper mb-4'}>
          <table
            className={'border border-collapse table-auto mx-auto'}>
            <tbody>
              {
                item.value.data.map(
                  (row, index) => {
                    return <tr
                      key={`row-${index}`}>
                      {
                        row.map(
                          (col, index) => {
                            return <td
                              key={`col-${index}`}
                              className={'border p-2'}>
                              {col}
                            </td>
                          }
                        )
                      }
                    </tr>
                  }
                )
              }
            </tbody>
          </table>
          {caption}
        </div>
      }

      if (item.type === 'figure') {
        const caption = item.value.caption
          ? <Typography
            tag={'figcaption'}
            size={'small'}
            className={'block italic text-gray-01 mt-2 text-center'}>
            <RawHTML html={item.value.caption} />
          </Typography>
          : ''

        return <figure
          key={item.id}
          className={'figure-wrapper mb-4'}>
          <Image
            src={item.value.image.meta.downloadUrl}
            alt={item.value.image.title}
            width={item.value.image.width}
            height={item.value.image.height}
            className={'block z-0'} />
          {caption}
        </figure>
      }

      return ''
    })
    : null
}

Body.propTypes = {
  content: PropTypes.array
}
export default Body
